export enum NOT_FOUND_REASONS_ENUM {
  SiteDsmNotEnabled = 'site-dsm-not-enabled',
  SiteExpired = 'site-expired',
  SiteNotFound = 'site-not-found',
}

export const NOT_FOUND_REASONS = {
  [NOT_FOUND_REASONS_ENUM.SiteDsmNotEnabled]: {
    message: 'siteDsmNotEnabled.',
  },
  [NOT_FOUND_REASONS_ENUM.SiteExpired]: {
    message: 'siteExpired.',
  },
  [NOT_FOUND_REASONS_ENUM.SiteNotFound]: {
    message: 'siteNotFound.',
  },
}
